export class MDWiseAccount {
    paymentAmount: number;
    applicationId: string;
    accountDate: Date;
    customerAccountId: string;
}
